var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteCross = function SvgWhiteCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 23-8-8 8-8-4-4-8 8-8-8-4 4 8 8-8 8 4 4 8-8 8 8 4-4Z",
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25 21-8-8 8-8-4-4-8 8-8-8-4 4 8 8-8 8 4 4 8-8 8 8 4-4Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default SvgWhiteCross;